import { useTranslation } from "react-i18next";
import { DownIcon } from "src/assets/Icons";
import { useGiftcardsListing } from "../../context/GiftcardsListingContext";

export default function Sorters() {
  const { t } = useTranslation();
  const { filters, setFilters } = useGiftcardsListing();

  const isBestSeller = filters.sortBy === "best_seller";

  const handleToggle = () => {
    setFilters((prev) => ({ ...prev, sortBy: isBestSeller ? undefined : "best_seller" }));
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      className="flex-1 h-full bg-background-default! text-font-default flex w-full cursor-pointer items-center justify-between gap-2 px-5 py-3 text-sm whitespace-nowrap rounded-xs"
    >
      <span>
        {t("Giftcards.sortBy")}: <span className={`font-semibold ${isBestSeller ? "text-font-active" : ""}`}>{t("Giftcards.sortByBestSeller")}</span>
      </span>
      <DownIcon className="h-3 w-3 shrink-0" transform={isBestSeller ? "scale(1,-1)" : ""} />
    </button>
  );
}
